import { backendApi } from '@/stores/backendApi'

export const useAdmin = () => {
    const { data } = backendApi.endpoints.getMyAdminInfo.useQueryState()
    return {
        isAdmin: !!data?._id,
        data,
    }
}
